module.exports = __webpack_public_path__ + "static/media/SCANTER.e5cbdef8.png";